import { autoinject, observable } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';
import { categoryDimensionTypeMap, MooringArticleCategoryFull, WeightTypeMap } from 'models/mooring';
import { MooringArticleCategoryService } from 'services';
import './mooring-article-category-container.scss';
import { AsyncErrorHandler } from 'lib/ui';
import { DialogService } from 'aurelia-dialog';
import { MooringArticleCategoryCreateEdit } from './mooring-article-category-create-edit';
import { MooringArticleTypeCreateEdit } from './mooring-article-type-create-edit';
import { MooringProductTypeCreateEdit } from './mooring-product-type-create-edit';

const nameIncludes = (entry: { Name: string; NameEn: string; NameEs?: string }, value?: string) => {
  return entry.Name.toLowerCase().includes(value) || entry.NameEn.toLowerCase().includes(value);
};

@autoinject()
export class MooringArticleCategoryContainer {
  protected headers: {
    title: string;
  }[] = [];

  constructor(private mooringArticleCategoryService: MooringArticleCategoryService, private t: I18N, private dialog: DialogService) {}

  protected weightUnits = WeightTypeMap;
  protected dimensions = categoryDimensionTypeMap;

  protected new_category_text = this.t.tr('general.new', { x: this.t.tr('general.category').toLowerCase() });
  protected add_type_text = this.t.tr('general.add', { x: this.t.tr('general.type').toLowerCase() });
  protected add_product_text = this.t.tr('general.add', { x: this.t.tr('general.product').toLowerCase() });

  protected async attached() {
    await this.getCategories();
  }

  protected expanded = {};

  @observable
  protected searchText: string | undefined = undefined;
  searchTextChanged(searchString: string) {
    if (!searchString) this.categories = this.allCategories;
    else searchString = searchString.toLowerCase();

    this.categories = this.allCategories;

    console.log('wer');

    // const expandCategories = new Set<number>()

    const m = structuredClone(this.allCategories);

    this.categories = m.filter((cat) => {
      const matchCategory = nameIncludes(cat, searchString);

      const types = cat.MooringArticleTypes.filter((at) => {
        const matchArticle = nameIncludes(at, searchString);
        const products = at.ProductTypes.filter((pr) => nameIncludes(pr, searchString));

        at.ProductTypes = products;
        return matchArticle || Boolean(products.length);
      });

      cat.MooringArticleTypes = types;

      return matchCategory || Boolean(types.length);
    });

    // const expandedIds = Array.from(expandCategories);

    this.categories.forEach((x) => (this.expanded[x.Id] = {}));
    if (!searchString || !this.categories.length) this.expanded = {};
  }

  protected toggleExpandsion(category: number, type?: number) {
    const expanded = structuredClone(this.expanded);

    if (category != undefined && type != undefined) {
      const typeExpanded = expanded[category][type];
      if (typeExpanded) delete expanded[category][type];
      else expanded[category][type] = true;
    } else if (category != undefined) {
      const catExpanded = expanded[category];
      if (catExpanded) expanded[category] = undefined;
      else expanded[category] = {};
    }

    this.expanded = expanded;
  }

  protected allCategories: MooringArticleCategoryFull[] = [];
  protected categories: MooringArticleCategoryFull[] = [];

  @AsyncErrorHandler
  protected async getCategories() {
    const { data } = await this.mooringArticleCategoryService.full();
    this.allCategories = data;
    this.categories = data;
  }

  protected createUpdateCategory(id?: number) {
    this.createUpdateModel(id, MooringArticleCategoryCreateEdit);
  }

  protected createUpdateModel(id: number | undefined, viewModel: object) {
    void this.dialog
      .open({
        viewModel,
        model: id ? { id } : undefined,
        position: () => ({}),
      })
      .whenClosed(() => {
        void this.getCategories();
        document.querySelector('html').style.overflowY = null;
      });
  }

  protected createUpdateType(typeId?: number, categoryId?: number, aquacomCategoryId?: number) {
    this.createUpdateTypeModel(typeId, categoryId, aquacomCategoryId);
  }

  protected createUpdateTypeModel(typeId: number | undefined, categoryId: number | undefined, aquacomCategoryId: number | undefined) {
    void this.dialog
      .open({
        viewModel: MooringArticleTypeCreateEdit,
        model: {
          typeId: typeId ? typeId : undefined,
          categoryId: categoryId ? categoryId : undefined,
          aquacomCategoryId: aquacomCategoryId ? aquacomCategoryId : undefined,
        },
        position: () => ({}),
      })
      .whenClosed(() => {
        void this.getCategories();
        document.querySelector('html').style.overflowY = null;
      });
  }

  protected createUpdateProduct(productId?: number, typeId?: number, aquacomTypeId?: number, categoryId?: number) {
    this.createUpdateProductModel(productId, typeId, aquacomTypeId, categoryId);
  }

  protected createUpdateProductModel(
    productId: number | undefined,
    typeId: number | undefined,
    aquacomTypeId: number | undefined,
    categoryId: number | undefined
  ) {
    void this.dialog
      .open({
        viewModel: MooringProductTypeCreateEdit,
        model: {
          productId: productId ? productId : undefined,
          typeId: typeId ? typeId : undefined,
          aquacomTypeId: aquacomTypeId ? aquacomTypeId : undefined,
          categoryId: categoryId ? categoryId : undefined,
        },
        position: () => ({}),
      })
      .whenClosed(() => {
        void this.getCategories();
        document.querySelector('html').style.overflowY = null;
      });
  }

  protected isCreating = false;
  protected editingCategory: number | undefined = undefined;
  protected setEditingCategory(id: number) {
    this.isCreating = false;
    this.editingCategory = id;
  }

  protected setIsCreatingCategory(isCreating: boolean) {
    this.editingCategory = undefined;
    this.isCreating = isCreating;
  }
}
